import { apiRequest } from '@/utils/api-request';

export type WorkflowDefaultSource =
  | 'platform_fallback'
  | 'organization_override';

export interface OrgSoftwareConfig {
  orgid: string;
  github_org: string;
  workflow_nodes_repo: string;
  default_workflow_repo: string;
  default_workflow_branch: string;
  default_workflow_repo_source: WorkflowDefaultSource;
  default_workflow_branch_source: WorkflowDefaultSource;
  updated_at?: string | null;
  updated_by?: string | null;
  created_at?: string | null;
}

export interface UpdateOrgSoftwareConfig {
  default_workflow_repo?: string;
  default_workflow_branch?: string;
}

const requireConfig = (
  data: OrgSoftwareConfig | undefined,
  detail: string | undefined,
): OrgSoftwareConfig => {
  if (detail) {
    throw new Error(detail);
  }
  if (!data) {
    throw new Error('Organization software configuration was not returned');
  }
  return data;
};

export const getOrgSoftwareConfig = async (
  orgId: string,
): Promise<OrgSoftwareConfig> => {
  const response = await apiRequest<OrgSoftwareConfig>({
    url: `/org-software-config/${orgId}`,
    method: 'GET',
    target: 'platform',
  });

  return requireConfig(response.data, response.detail);
};

export const updateOrgSoftwareConfig = async (
  orgId: string,
  update: UpdateOrgSoftwareConfig,
): Promise<OrgSoftwareConfig> => {
  const response = await apiRequest<OrgSoftwareConfig>({
    url: `/org-software-config/${orgId}`,
    method: 'PATCH',
    target: 'platform',
    body: { ...update },
  });

  return requireConfig(response.data, response.detail);
};
